import { NgModule } from "@angular/core";
import { FaIconLibrary, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
  faCreativeCommons,
  faCreativeCommonsBy,
  faCreativeCommonsNc,
  faCreativeCommonsNcEu,
  faCreativeCommonsNd,
  faCreativeCommonsSa,
  faFacebook,
  faTwitter,
  faWhatsapp,
  faApplePay,
  faGooglePay,
  faAlipay,
  faStripe,
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcDiscover,
  faPaypal
} from "@fortawesome/free-brands-svg-icons";
import {
  faBookmark as farBookmark,
  faCheckCircle as farCheckCircle,
  faCircle as farCircle,
  faClock as farClock,
  faComment as farComment,
  faCopyright as farCopyright,
  faFile as farFile,
  faFolder as farFolder,
  faStar as farStar,
  faThumbsUp as farThumbsUp,
  faUser as farUser
} from "@fortawesome/free-regular-svg-icons";
import {
  faAdjust,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowCircleUp,
  faArrowDown,
  faArrowLeft,
  faArrowPointer,
  faArrowRight,
  faArrowsAltH,
  faArrowsAltV,
  faArrowsLeftRight,
  faArrowsLeftRightToLine,
  faArrowsUpDown,
  faArrowTurnUp,
  faArrowUp,
  faArrowUpFromBracket,
  faAsterisk,
  faAtom,
  faAward,
  faBalanceScale,
  faBan,
  faBarcode,
  faBars,
  faBarsStaggered,
  faBell,
  faBellSlash,
  faBold,
  faBolt,
  faBookmark,
  faCalendar,
  faCalendarAlt,
  faCalendarXmark,
  faCamera,
  faCameraRetro,
  faChartBar,
  faChartLine,
  faChartSimple,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChevronCircleLeft,
  faChevronCircleRight,
  faCircleExclamation,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleChevronDown,
  faCircleChevronUp,
  faCircleDot,
  faCircleHalfStroke,
  faCircleMinus,
  faCircleNotch,
  faCirclePlus,
  faCircleXmark,
  faClock,
  faCloudUploadAlt,
  faCode,
  faCompress,
  faCog,
  faComment,
  faCommentAlt,
  faCommentDollar,
  faComments,
  faCompass,
  faComputerMouse,
  faCopy,
  faCopyright,
  faCrosshairs,
  faDatabase,
  faDollar,
  faDownLeftAndUpRightToCenter,
  faDroplet,
  faDumbbell,
  faEarthAfrica,
  faEarthAmericas,
  faEarthAsia,
  faEarthEurope,
  faEarthOceania,
  faEdit,
  faEllipsis,
  faEllipsisV,
  faEllipsisVertical,
  faEnvelope,
  faEquals,
  faEraser,
  faEuroSign,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faEye,
  faEyeDropper,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileCsv,
  faFileExport,
  faFileInvoice,
  faFilter,
  faFire,
  faFlag,
  faFlagUsa,
  faFolder,
  faFolderOpen,
  faFont,
  faFrown,
  faGavel,
  faGlobe,
  faGraduationCap,
  faGrip,
  faGripVertical,
  faHammer,
  faHandPaper,
  faHandPointer,
  faHandshake,
  faHashtag,
  faHeading,
  faHeart,
  faHistory,
  faHome,
  faHourglass,
  faIcicles,
  faImage,
  faImages,
  faInbox,
  faInfo,
  faInfoCircle,
  faItalic,
  faKey,
  faKeyboard,
  faLanguage,
  faLaptop,
  faLaptopCode,
  faLayerGroup,
  faLightbulb,
  faLink,
  faListAlt,
  faListOl,
  faListUl,
  faLocationArrow,
  faLock,
  faUnlock,
  faMagnifyingGlass,
  faMap,
  faMapMarkerAlt,
  faMeh,
  faMicrochip,
  faMinus,
  faMoneyBill,
  faMoon,
  faMousePointer,
  faNoteSticky,
  faPaperclip,
  faPaperPlane,
  faPen,
  faPencil,
  faPersonWalkingArrowRight,
  faPause,
  faPlay,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faQuestion,
  faQuestionCircle,
  faQuoteLeft,
  faQuoteRight,
  faRainbow,
  faReceipt,
  faRedo,
  faRepeat,
  faReply,
  faRobot,
  faRotateLeft,
  faRotate,
  faRss,
  faRuler,
  faSackDollar,
  faSave,
  faSearch,
  faShare,
  faShareAlt,
  faShareNodes,
  faShieldAlt,
  faShieldHalved,
  faShop,
  faShoppingCart,
  faSignInAlt,
  faSignOutAlt,
  faSliders,
  faSmile,
  faSnowflake,
  faSort,
  faSortAlphaDown,
  faSortAlphaUp,
  faSortAmountDown,
  faSortDown,
  faSortNumericDown,
  faSortNumericUp,
  faSortUp,
  faSpinner,
  faSquare,
  faSquareFull,
  faSquareRootAlt,
  faStar,
  faStarHalfStroke,
  faStore,
  faStrikethrough,
  faSun,
  faSync,
  faTableCells,
  faTableCellsLarge,
  faTachometerAlt,
  faTag,
  faTags,
  faTasks,
  faTemperatureHigh,
  faTerminal,
  faTextHeight,
  faThermometer,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faTrophy,
  faUnderline,
  faUndo,
  faUnlink,
  faUpload,
  faUser,
  faUserCircle,
  faUserGroup,
  faUserPlus,
  faUsers,
  faUserTimes,
  faVideo,
  faCreditCard,
  faLockOpen,
  faFileUpload,
  faAd,
  faInfinity,
  faSearchPlus,
  faDownload,
  faFileArchive,
  faTrashRestore,
  faTools,
  faToolbox,
  faSearchLocation,
  faPiggyBank,
  faRocket,
  faHeadset,
  faList,
  faSeedling
} from "@fortawesome/free-solid-svg-icons";

@NgModule({
  imports: [FontAwesomeModule],
  exports: [FontAwesomeModule]
})
export class IconsModule {
  constructor(library: FaIconLibrary) {
    // Add brands icons
    library.addIcons(
      faFacebook,
      faTwitter,
      faWhatsapp,
      faCreativeCommons,
      faCreativeCommonsBy,
      faCreativeCommonsSa,
      faCreativeCommonsNc,
      faCreativeCommonsNd,
      faCreativeCommonsNcEu,
      faApplePay,
      faGooglePay,
      faAlipay,
      faStripe,
      faCcVisa,
      faCcMastercard,
      faCcAmex,
      faCcDiscover,
      faPaypal
    );

    // Add regular icons
    library.addIcons(
      farStar,
      farCircle,
      farCheckCircle,
      farBookmark,
      farComment,
      farCopyright,
      farClock,
      farFile,
      farFolder,
      farThumbsUp,
      farUser
    );

    // Add solid icons
    library.addIcons(
      faAdjust,
      faAngleDoubleLeft,
      faAngleDoubleRight,
      faAngleDown,
      faAngleLeft,
      faAngleRight,
      faAngleUp,
      faArrowCircleUp,
      faArrowDown,
      faArrowLeft,
      faArrowPointer,
      faArrowRight,
      faArrowUp,
      faArrowUpFromBracket,
      faArrowsAltH,
      faArrowsAltV,
      faArrowsLeftRight,
      faArrowsLeftRightToLine,
      faArrowsUpDown,
      faAsterisk,
      faAward,
      faBan,
      faBarcode,
      faBars,
      faBarsStaggered,
      faBell,
      faBellSlash,
      faBold,
      faBolt,
      faCompress,
      faBookmark,
      faCalendar,
      faCalendarAlt,
      faCalendarXmark,
      faCamera,
      faCameraRetro,
      faChartLine,
      faChartSimple,
      faCheck,
      faCheckCircle,
      faChevronCircleLeft,
      faChevronCircleRight,
      faCircleExclamation,
      faChevronLeft,
      faChevronRight,
      faChevronUp,
      faChevronDown,
      faCircle,
      faCircleCheck,
      faCircleChevronDown,
      faCircleChevronUp,
      faCircleDot,
      faCircleHalfStroke,
      faCircleMinus,
      faCircleNotch,
      faCirclePlus,
      faCircleXmark,
      faCloudUploadAlt,
      faClock,
      faCode,
      faCog,
      faComment,
      faCommentAlt,
      faCommentDollar,
      faComments,
      faCompass,
      faComputerMouse,
      faCopy,
      faCopyright,
      faCrosshairs,
      faDatabase,
      faDollar,
      faDownLeftAndUpRightToCenter,
      faDroplet,
      faEarthAfrica,
      faEarthAmericas,
      faEarthAsia,
      faEarthEurope,
      faEarthOceania,
      faEdit,
      faEllipsis,
      faEllipsisV,
      faEllipsisVertical,
      faEnvelope,
      faEquals,
      faEuroSign,
      faExclamationCircle,
      faExclamationTriangle,
      faExpand,
      faEye,
      faEyeSlash,
      faFile,
      faFileAlt,
      faFileCsv,
      faFileExport,
      faFileInvoice,
      faFilter,
      faFlag,
      faFlagUsa,
      faFolder,
      faFolderOpen,
      faGavel,
      faGlobe,
      faGraduationCap,
      faGrip,
      faGripVertical,
      faHammer,
      faHandshake,
      faHashtag,
      faHeading,
      faHeart,
      faHistory,
      faHome,
      faHourglass,
      faIcicles,
      faImage,
      faImages,
      faInbox,
      faInfo,
      faInfoCircle,
      faItalic,
      faKey,
      faLaptop,
      faLaptopCode,
      faLayerGroup,
      faLightbulb,
      faLink,
      faListAlt,
      faListOl,
      faListUl,
      faLock,
      faUnlock,
      faMap,
      faMapMarkerAlt,
      faMicrochip,
      faMinus,
      faMoneyBill,
      faMoon,
      faNoteSticky,
      faPaperclip,
      faPen,
      faPencil,
      faPause,
      faPlay,
      faPlayCircle,
      faPlus,
      faQuestion,
      faQuestionCircle,
      faQuoteLeft,
      faQuoteRight,
      faReceipt,
      faRedo,
      faPaperPlane,
      faReply,
      faRobot,
      faRotate,
      faRotateLeft,
      faRss,
      faSackDollar,
      faSave,
      faSearch,
      faShare,
      faShareAlt,
      faShareNodes,
      faShop,
      faShoppingCart,
      faSignInAlt,
      faSignOutAlt,
      faSliders,
      faSmile,
      faSnowflake,
      faSort,
      faSortAlphaDown,
      faSortAlphaUp,
      faSortAmountDown,
      faSortNumericDown,
      faSortNumericUp,
      faSortDown,
      faSortUp,
      faSpinner,
      faSquare,
      faSquareFull,
      faSquareRootAlt,
      faStar,
      faStarHalfStroke,
      faStore,
      faStrikethrough,
      faSun,
      faSync,
      faTableCells,
      faTableCellsLarge,
      faTag,
      faTags,
      faTasks,
      faTemperatureHigh,
      faTerminal,
      faTextHeight,
      faThumbsDown,
      faThumbsUp,
      faThumbtack,
      faTimes,
      faTimesCircle,
      faTrash,
      faTrashAlt,
      faTrophy,
      faUnderline,
      faUndo,
      faUnlink,
      faUpload,
      faUser,
      faUserCircle,
      faUserGroup,
      faUserPlus,
      faUsers,
      faUserTimes,
      faPersonWalkingArrowRight,
      faFrown,
      faHandPaper,
      faRuler,
      faEyeDropper,
      faFire,
      faThermometer,
      faAtom,
      faVideo,
      faRainbow,
      faPlusCircle,
      faBalanceScale,
      faDumbbell,
      faTachometerAlt,
      faCreditCard,
      faLockOpen,
      faMousePointer,
      faRepeat,
      faExternalLinkAlt,
      faArrowTurnUp,
      faHandPointer,
      faMagnifyingGlass,
      faLanguage,
      faChartBar,
      faLocationArrow,
      faMeh,
      faKeyboard,
      faEraser,
      faFont,
      faCheckSquare,
      faExclamationTriangle,
      faCircleDot,
      faCircleCheck,
      faShieldAlt,
      faShieldHalved,
      faFileUpload,
      faAd,
      faInfinity,
      faSearchPlus,
      faDownload,
      faFileArchive,
      faTrashRestore,
      faTools,
      faToolbox,
      faSearchLocation,
      faPiggyBank,
      faRocket,
      faHeadset,
      faList,
      faSeedling
    );
  }
}
